var map = {
	"./layouts/card": 16,
	"./layouts/card/": 16,
	"./layouts/card/index": 16,
	"./layouts/card/index.tsx": 16,
	"./layouts/card/style.module": 103,
	"./layouts/card/style.module.scss": 103,
	"./layouts/components/breadcrumbs": 135,
	"./layouts/components/breadcrumbs/": 135,
	"./layouts/components/breadcrumbs/index": 135,
	"./layouts/components/breadcrumbs/index.tsx": 135,
	"./layouts/components/breadcrumbs/style.module": 194,
	"./layouts/components/breadcrumbs/style.module.scss": 194,
	"./layouts/components/container": 49,
	"./layouts/components/container/": 49,
	"./layouts/components/container/index": 49,
	"./layouts/components/container/index.tsx": 49,
	"./layouts/components/container/style.module": 137,
	"./layouts/components/container/style.module.scss": 137,
	"./layouts/components/footer": 136,
	"./layouts/components/footer/": 136,
	"./layouts/components/footer/index": 136,
	"./layouts/components/footer/index.tsx": 136,
	"./layouts/components/footer/style.module": 94,
	"./layouts/components/footer/style.module.scss": 94,
	"./layouts/components/loading_indicator": 55,
	"./layouts/components/loading_indicator/": 55,
	"./layouts/components/loading_indicator/index": 55,
	"./layouts/components/loading_indicator/index.tsx": 55,
	"./layouts/components/nav_bar": 102,
	"./layouts/components/nav_bar/": 102,
	"./layouts/components/nav_bar/index": 102,
	"./layouts/components/nav_bar/index.tsx": 102,
	"./layouts/components/nav_bar/standalone": 365,
	"./layouts/components/nav_bar/standalone.tsx": 365,
	"./layouts/components/nav_bar/style.module": 37,
	"./layouts/components/nav_bar/style.module.scss": 37,
	"./layouts/components/notice_banner": 93,
	"./layouts/components/notice_banner/": 93,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 195,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 195,
	"./layouts/components/notice_banner/index": 93,
	"./layouts/components/notice_banner/index.tsx": 93,
	"./layouts/components/notice_banner/standalone": 366,
	"./layouts/components/notice_banner/standalone.tsx": 366,
	"./layouts/components/notice_banner/style.module": 196,
	"./layouts/components/notice_banner/style.module.scss": 196,
	"./layouts/page": 105,
	"./layouts/page/": 105,
	"./layouts/page/index": 105,
	"./layouts/page/index.tsx": 105,
	"./layouts/page/style.module": 95,
	"./layouts/page/style.module.scss": 95,
	"./layouts/types": 367,
	"./layouts/types.ts": 367,
	"./marketing/pages/home/toefl": 1569,
	"./marketing/pages/home/toefl/": 1569,
	"./marketing/pages/home/toefl/index": 1569,
	"./marketing/pages/home/toefl/index.tsx": 1569,
	"./marketing/pages/home/toefl/sections/ai": 1161,
	"./marketing/pages/home/toefl/sections/ai/": 1161,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature": 1788,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature.png": 1788,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature": 1789,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature.png": 1789,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature": 1790,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature.png": 1790,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature": 1791,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature.png": 1791,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge": 1792,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge.svg": 1792,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg": 1793,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg.svg": 1793,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon": 1794,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon.svg": 1794,
	"./marketing/pages/home/toefl/sections/ai/index": 1161,
	"./marketing/pages/home/toefl/sections/ai/index.tsx": 1161,
	"./marketing/pages/home/toefl/sections/ai/style.module": 1795,
	"./marketing/pages/home/toefl/sections/ai/style.module.scss": 1795,
	"./marketing/pages/home/toefl/sections/apps": 1162,
	"./marketing/pages/home/toefl/sections/apps/": 1162,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon": 1796,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon.svg": 1796,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon": 1797,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon.svg": 1797,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app": 1798,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app.png": 1798,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon": 1799,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon.svg": 1799,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app": 1800,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app.png": 1800,
	"./marketing/pages/home/toefl/sections/apps/index": 1162,
	"./marketing/pages/home/toefl/sections/apps/index.tsx": 1162,
	"./marketing/pages/home/toefl/sections/features": 1163,
	"./marketing/pages/home/toefl/sections/features/": 1163,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature": 1801,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature.png": 1801,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature": 1802,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature.png": 1802,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature": 1803,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature.png": 1803,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon": 1804,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon.svg": 1804,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature": 1805,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature.png": 1805,
	"./marketing/pages/home/toefl/sections/features/index": 1163,
	"./marketing/pages/home/toefl/sections/features/index.tsx": 1163,
	"./marketing/pages/home/toefl/sections/official_questions": 1167,
	"./marketing/pages/home/toefl/sections/official_questions/": 1167,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen": 1814,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen.png": 1814,
	"./marketing/pages/home/toefl/sections/official_questions/index": 1167,
	"./marketing/pages/home/toefl/sections/official_questions/index.tsx": 1167,
	"./marketing/pages/home/toefl/sections/official_questions/style.module": 697,
	"./marketing/pages/home/toefl/sections/official_questions/style.module.scss": 697,
	"./marketing/pages/home/toefl/sections/value_props": 1164,
	"./marketing/pages/home/toefl/sections/value_props/": 1164,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles": 1806,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles.svg": 1806,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon": 1807,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon.svg": 1807,
	"./marketing/pages/home/toefl/sections/value_props/index": 1164,
	"./marketing/pages/home/toefl/sections/value_props/index.tsx": 1164,
	"./marketing/pages/home/toefl/sections/value_props/style.module": 2188,
	"./marketing/pages/home/toefl/sections/value_props/style.module.scss": 2188,
	"./marketing/pages/home/toefl/sections/video_based_learning": 1165,
	"./marketing/pages/home/toefl/sections/video_based_learning/": 1165,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card": 1808,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card.png": 1808,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg": 1809,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg.png": 1809,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot": 1810,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot.png": 1810,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon": 1811,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon.svg": 1811,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail": 1812,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail.png": 1812,
	"./marketing/pages/home/toefl/sections/video_based_learning/index": 1165,
	"./marketing/pages/home/toefl/sections/video_based_learning/index.tsx": 1165,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module": 696,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module.scss": 696,
	"./marketing/pages/home/toefl/sections/wall_of_love": 1166,
	"./marketing/pages/home/toefl/sections/wall_of_love/": 1166,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot": 1813,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot.png": 1813,
	"./marketing/pages/home/toefl/sections/wall_of_love/index": 1166,
	"./marketing/pages/home/toefl/sections/wall_of_love/index.tsx": 1166,
	"./marketing/pages/home/toefl/style.module": 1815,
	"./marketing/pages/home/toefl/style.module.scss": 1815,
	"./marketing/pages/plans/toefl": 1570,
	"./marketing/pages/plans/toefl/": 1570,
	"./marketing/pages/plans/toefl/index": 1570,
	"./marketing/pages/plans/toefl/index.tsx": 1570,
	"./marketing/pages/plans/toefl/sections/testimonials": 1168,
	"./marketing/pages/plans/toefl/sections/testimonials/": 1168,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot": 1816,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot.png": 1816,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot": 1817,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot.png": 1817,
	"./marketing/pages/plans/toefl/sections/testimonials/index": 1168,
	"./marketing/pages/plans/toefl/sections/testimonials/index.tsx": 1168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2526;